<script>
import { Page, Footer } from "@styled/global";

export default {
   render() {
      return (
         <Page>
            <ShadowHeader />
            <Engagement copy="refinance-engagement" />
            <SingleColumnContent copy="refinance-subheader" primary />
            <SingleColumnContent copy="refinance-rates-subheader" color="red" />
            <MortgageRateTable copy="mortgage-rates-table" />
            <Collapsible copy="collapsible-sample1">
               <ContentBlock copy="collapsible-sample1" />
            </Collapsible>
            <AdPanels copy="refinance-box-ads" />
            <Collapsible copy="collapsible-refinance-products">
               <BulletSection copy="box-section" />
            </Collapsible>
            <LoanNavigator copy="home-loans-navigator" />
            <Video copy="video" />
            <Faq copy="refinance-faq" />
            <Footer>
               <Disclosures copy="collapsible-disclosures" />
               <PowerFooter copy="refinance-power-footer" />
               <FooterNavigation copy="mortgage-footer-navigation" />
               <FooterCopyright copy="copyright" />
            </Footer>
         </Page>
      );
   },
};
</script>
